import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import {
  beforeEnterNegocio,
  beforeEnterRestaurante,
  beforeEnterNegocioBossRestaurante,
  beforeEnterNegocioBossNegocio,
  beforeEnterRestauranteBossNegocio,
  goPanel,
  beforeEnterPartner,
  beforeEnterDirectorio,
  beforeEnterDirectorioBossDirectorio,
} from '@/utils/router.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/front/Index'),
      name: 'FUNEAT',
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/front/Login'),
        },
        {
          name: 'Bloquear',
          path: 'lock',
          component: () => import('@/views/front/Lock'),
        },
        {
          name: 'Comprobar Firma Contrato',
          path: 'comprobarfirma',
          component: () => import('@/views/front/CheckContrato'),
        },
      ],
    },
    {
      path: '/admin',
      component: () => import('@/views/admin/Index'),
      meta: {
        auth: true,
      },
      children: [
        //partner
        {
          path: 'partner/panel',
          name: 'Panel Administración Partner',
          component: () => import('@/views/partner/DashboardPartner'),
          meta: {
            auth: true,
            role: ['partner'],
          },
          beforeEnter: beforeEnterPartner,
        },
        {
          path: 'partner/contratos',
          name: 'Contratos Partner',
          component: () => import('@/views/partner/ContratosPartner'),
          meta: {
            auth: true,
            role: ['partner'],
          },
          beforeEnter: beforeEnterPartner,
        },
        {
          path: 'partner/facturacion',
          name: 'Facturación asociados Partner',
          component: () => import('@/views/partner/FacturacionPartner'),
          meta: {
            auth: true,
            role: ['partner'],
          },
          beforeEnter: beforeEnterPartner,
        },
        {
          path: 'partner/comisiones',
          name: 'Comisiones partner',
          component: () => import('@/views/partner/ComisionesPartner'),
          meta: {
            auth: true,
            role: ['partner'],
          },
          beforeEnter: beforeEnterPartner,
        },
        //directorios
        {
          path: 'directorio/panel',
          name: 'Panel Administración Directorio',
          component: () => import('@/views/directorio/DashboardDirectorio'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        {
          path: 'directorio/pedidos/ver/:id',
          name: 'Ver pedido',
          component: () => import('@/views/admin/PedidosFormAdmin'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        {
          path: 'directorio/facturacion',
          name: 'Facturación asociados Directorio',
          component: () => import('@/views/directorio/FacturacionDirectorio'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        {
          path: 'directorio/contratos',
          name: 'Contratos Directorio',
          component: () => import('@/views/directorio/ContratosDirectorio'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        {
          path: 'directorio/historialpedidos',
          name: 'Historial Pedidos Directorio',
          component: () => import('@/views/admin/EstadisticasAdmin'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        {
          path: 'directorio/estadisticas',
          name: 'Estadisticas Directorio',
          component: () => import('@/views/directorio/EstadisticasDirectorio'),
          meta: {
            auth: true,
            role: ['boss_directorio'],
          },
          beforeEnter: beforeEnterDirectorioBossDirectorio,
        },
        //negocios
        {
          path: 'negocio/panel',
          name: 'Panel Administración',
          component: () => import('@/views/negocio/DashboardNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },

        {
          path: 'negocio/clientes',
          name: 'Clientes',
          component: () => import('@/views/negocio/ClientesNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/pedidos',
          name: 'Pedidos Restaurante',
          component: () => import('@/views/negocio/PedidosNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/pedidos/ver/:id',
          name: 'Ver pedido',
          component: () => import('@/views/admin/PedidosFormAdmin'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        //configuración retaurante negocio
        {
          path: 'negocio/restaurantes/:rest/configuracion',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/ConfiguracionRest.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterRestauranteBossNegocio,
        },

        {
          path: 'negocio/restaurantes',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/RestaurantesNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/productos',
          name: 'Productos',
          component: () => import('@/views/negocio/ProductosNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/historialpedidos',
          name: 'Historial Pedidos Negocio',
          component: () => import('@/views/admin/EstadisticasAdmin'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          name: 'Estadísticas Negocio',
          path: 'negocio/estadisticas',
          component: () => import('@/views/admin/EstadisticasBQAdmin'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          name: 'ZCierres',
          path: 'negocio/zcierres',
          component: () => import('@/views/negocio/ZCierreListado'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          name: 'Contabilidad',
          path: 'negocio/contabilidad',
          component: () => import('@/views/negocio/Contabilidad'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          name: 'ZCierres',
          path: 'negocio/zcierres/:idcierre',
          component: () => import('@/views/negocio/ZCierreForm'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          name: 'Facturación Negocio',
          path: 'negocio/facturacion',
          component: () => import('@/views/negocio/FacturacionNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/contratos',
          name: 'Contratos Negocio',
          component: () => import('@/views/negocio/ContratosNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/internos/listado',
          name: 'Pedidos Internos Negocio',
          component: () => import('@/views/negocio/PedidosInternosNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/internos/productos',
          name: 'Productos pedidos internos',
          component: () => import('@/views/internos/InternosProductos'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/internos/categorias',
          name: 'Categorías pedidos internos',
          component: () => import('@/views/internos/InternosCategorias'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/notificaciones',
          name: 'Notificaciones Negocio',
          component: () => import('@/views/negocio/NotificacionesNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/notificaciones/add/:id_not',
          name: 'Editar Notificación',
          component: () =>
            import('@/views/negocio/NotificacionesFormNegocio.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/notificaciones/respuestas/:id_not',
          name: 'Ver respuestas notificación',
          component: () =>
            import('@/views/negocio/NotificacionesNegocioRespuestas.vue'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/notificaciones/add',
          name: 'Crear Notificación',
          component: () => import('@/views/negocio/NotificacionesFormNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        //noticias
        {
          path: 'negocio/noticias',
          name: 'Noticias',
          component: () => import('@/views/negocio/NoticiasNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/noticias/form',
          name: 'Crear Noticia',
          component: () => import('@/views/negocio/NoticiasFormNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        {
          path: 'negocio/noticias/form/:id_noticia',
          name: 'Editar Noticia',
          component: () => import('@/views/negocio/NoticiasFormNegocio'),
          meta: {
            auth: true,
            role: ['boss_negocio'],
          },
          beforeEnter: beforeEnterNegocioBossNegocio,
        },
        //restaurantes
        {
          path: 'rest/panel',
          name: 'Panel Administración',
          component: () => import('@/views/restaurante/DashboardRestaurante'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          path: 'rest/clientes',
          name: 'Clientes',
          component: () =>
            import('@/views/restaurante/ClientesRestaurante.vue'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          path: 'rest/pedidos',
          name: 'Pedidos Restaurante',
          component: () => import('@/views/restaurante/PedidosRestaurante.vue'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          path: 'rest/stats',
          name: 'Estadísticas Restaurante',
          component: () => import('@/views/admin/EstadisticasBQAdmin'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          path: 'rest/contratos',
          name: 'Contratos Restaurante',
          component: () => import('@/views/restaurante/ContratosRestaurante'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          name: 'Facturación Restaurante',
          path: 'rest/facturacion',
          component: () =>
            import('@/views/restaurante/FacturacionRestaurante.vue'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },
        {
          path: 'rest/internos',
          name: 'Pedidos Internos Restaurante',
          component: () =>
            import('@/views/restaurante/PedidosInternosRestaurante.vue'),
          meta: {
            auth: true,
            role: ['boss_restaurante'],
          },
          beforeEnter: beforeEnterNegocioBossRestaurante,
        },

        //admin
        {
          path: 'panel',
          name: 'Panel Administración',
          component: () => import('@/views/admin/Dashboard'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          path: 'alertas',
          name: 'Alertas',
          component: () => import('@/views/admin/AlertasAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          path: 'pedidos',
          name: 'Pedidos',
          component: () => import('@/views/admin/PedidosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          path: 'pedidos/view/:id',
          name: 'Ver pedido',
          component: () => import('@/views/admin/PedidosFormAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Negocios',
          path: 'negocios',
          component: () => import('@/views/admin/NegociosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Directorios',
          path: 'directorios',
          component: () => import('@/views/admin/DirectoriosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Partners',
          path: 'partners',
          component: () => import('@/views/admin/PartnersAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Impuestos',
          path: 'impuestos',
          component: () => import('@/views/admin/ImpuestosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Usuarios',
          path: 'usuarios',
          component: () => import('@/views/admin/UsuariosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Usuario',
          path: 'usuario/:idusuario',
          component: () => import('@/views/admin/UsuariosFormAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Usuario',
          path: 'usuario/:idusuario/pedidos',
          component: () => import('@/views/admin/UsuariosPedidosAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Características',
          path: 'caracteristicas',
          component: () => import('@/views/admin/CaracteristicasAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Tipo Cocinas',
          path: 'cocinas',
          component: () => import('@/views/admin/CocinasAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Estadisticas',
          path: 'estadisticas',
          component: () => import('@/views/admin/EstadisticasAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Estadisticas',
          path: 'estadisticas-bq',
          component: () => import('@/views/admin/EstadisticasBQAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Facturacion',
          path: 'facturacion',
          component: () => import('@/views/admin/FacturacionAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Disputas',
          path: 'disputas',
          component: () => import('@/views/admin/DisputasAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Contratos',
          path: 'contratos',
          component: () => import('@/views/admin/ContratosListado'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Contratos',
          path: 'contratos/form',
          component: () => import('@/views/admin/ContratosForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Contratos',
          path: 'contratos/plantillas',
          component: () => import('@/views/admin/ContratosPlantillas'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Nueva Factura',
          path: 'facturacion/form',
          component: () => import('@/views/admin/FacturacionNuevaAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Ver Factura',
          path: 'facturacion/form/:id_factura',
          component: () => import('@/views/admin/FacturacionNuevaAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Copias de seguridad',
          path: 'backup',
          component: () => import('@/views/admin/BackupAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Nueva copia de seguridad',
          path: 'backup/form',
          component: () => import('@/views/admin/BackupFormAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        {
          name: 'Ver copia',
          path: 'backup/form/:id',
          component: () => import('@/views/admin/BackupFormAdmin'),
          meta: {
            auth: true,
            role: ['admin'],
          },
        },
        //GESTIÓN DIRECTORIO
        {
          path: 'directorio/:directorio/web',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterDirectorio,
        },
        {
          path: 'directorio/:directorio/web/dinamica',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropioDinamicaForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterDirectorio,
        },
        {
          path: 'directorio/:directorio/web/dinamica/:id',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropioDinamicaForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterDirectorio,
        },
        {
          path: 'directorio/:directorio/configuracion',
          name: 'Web',
          component: () => import('@/views/directorio/Configuracion'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterDirectorio,
        },
        //GESTIÓN NEGOCIO
        {
          path: 'gest/:negocio/',
          name: 'Panel Gestión Negocio',
          component: () => import('@/views/negocio/PanelNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        // {
        //   path: 'gest/:negocio/categorias',
        //   name: 'Categorias',
        //   component: () => import('@/views/negocio/CategoriasNegocio'),
        //   meta: {
        //     auth: true,
        //     role: ['admin']
        //   },
        //   beforeEnter: beforeEnterNegocio
        // },
        {
          path: 'gest/:negocio/carta',
          name: 'Carta',
          component: () => import('@/views/negocio/CartaNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        // {
        //   path: 'gest/:negocio/productos',
        //   name: 'Productos',
        //   component: () => import('@/views/negocio/ProductosNegocio'),
        //   meta: {
        //     auth: true,
        //     role: ['admin']
        //   },
        //   beforeEnter: beforeEnterNegocio
        // },

        {
          path: 'gest/:negocio/productoscruzados',
          name: 'Productos Cruzados',
          component: () => import('@/views/negocio/ProductosCruzados.vue'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/descuentos',
          name: 'Descuentos',
          component: () => import('@/views/negocio/DescuentosNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/descuentos/add',
          name: 'Descuentos',
          component: () => import('@/views/negocio/DescuentosFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/descuentos/edit/:idDescuento',
          name: 'Descuentos',
          component: () => import('@/views/negocio/DescuentosFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/cupones',
          name: 'Cupones',
          component: () => import('@/views/negocio/CuponesNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/cupones/add',
          name: 'Cupones',
          component: () => import('@/views/negocio/CuponesFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/cupones/edit/:idcupon',
          name: 'Cupones',
          component: () => import('@/views/negocio/CuponesFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        //Almacen
        {
          path: 'gest/:negocio/almacen/productos',
          name: 'Productos Negocio',
          component: () => import('@/views/negocio/ProductosNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/productos',
          name: 'Productos Negocio',
          component: () => import('@/views/negocio/ProductosNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/tarifas',
          name: 'Tarifas Negocio',
          component: () => import('@/views/negocio/TarifasNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/productos/edit/:idProducto',
          name: 'Producto Negocio',
          component: () => import('@/views/negocio/ProductosFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/productos/add',
          name: 'Producto Negocio',
          component: () => import('@/views/negocio/ProductosFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/productos/precios',
          name: 'Precios Productos Negocio',
          component: () => import('@/views/negocio/ProductosPreciosNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/productos/add',
          name: 'Producto Negocio',
          component: () => import('@/views/negocio/ProductosFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/categorias',
          name: 'Categorias Negocio',
          component: () => import('@/views/negocio/CategoriasNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/menus',
          name: 'Menús Negocio',
          component: () => import('@/views/negocio/MenusNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },

        {
          path: 'gest/:negocio/almacen/menus/form/:id',
          name: 'Editar Menú',
          component: () => import('@/views/negocio/MenusNegocioForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/menus/form/',
          name: 'Añadir Menu',
          component: () => import('@/views/negocio/MenusNegocioForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/modificadores',
          name: 'Modificadores Productos',
          component: () => import('@/views/negocio/ModificadoresNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/modificadores/form/:id',
          name: 'Editar Modificador',
          component: () => import('@/views/negocio/ModificadoresFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/modificadores/form/',
          name: 'Añadir Modificador',
          component: () => import('@/views/negocio/ModificadoresFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/gruposmodificadores',
          name: 'Grupos Modificadores Productos',
          component: () => import('@/views/negocio/GruposModificadoresNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/gruposmodificadores/form',
          name: 'Añadir grupo modificador',
          component: () =>
            import('@/views/negocio/GruposModificadoresFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/almacen/gruposmodificadores/form/:id',
          name: 'Editar grupo modificador',
          component: () =>
            import('@/views/negocio/GruposModificadoresFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },

        //Fin almacen

        // {
        //   path: 'gest/:negocio/productos/add',
        //   name: 'Productos',
        //   component: () => import('@/views/negocio/ProductosFormNegocio'),
        //   meta: {
        //     auth: true,
        //     role: ['admin']
        //   },
        //   beforeEnter: beforeEnterNegocio
        // },
        // {
        //   path: 'gest/:negocio/productos/edit/:idProducto',
        //   name: 'Productos',
        //   component: () => import('@/views/negocio/ProductosFormNegocio'),
        //   meta: {
        //     auth: true,
        //     role: ['admin']
        //   },
        //   beforeEnter: beforeEnterNegocio
        // },
        {
          path: 'gest/:negocio/almacen/productos/lote/:idProducto',
          name: 'Productos por Lotes',
          component: () => import('@/views/negocio/ProductosNegocioLotes'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/mapeo',
          name: 'Productos',
          component: () => import('@/views/negocio/MapeoNeoNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/vromo',
          name: 'Productos',
          component: () => import('@/views/negocio/VromoNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        // {
        //   path: 'gest/:negocio/stats',
        //   name: 'Estadísticas',
        //   component: () => import('@/views/negocio/EstadisticasNegocio.vue'),
        //   meta: {
        //     auth: true,
        //     role: ['admin']
        //   },
        //   beforeEnter: beforeEnterNegocio
        // },
        {
          path: 'gest/:negocio/totems',
          name: 'Totems',
          component: () => import('@/views/negocio/TotemsNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/tickets',
          name: 'Tickets',
          component: () => import('@/views/negocio/TicketsNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/web',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/web/dinamica',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropioDinamicaForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/web/dinamica/:id',
          name: 'Web',
          component: () => import('@/views/negocio/WebPropioDinamicaForm'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/restaurantes',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/RestaurantesNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/clientes',
          name: 'Clientes',
          component: () => import('@/views/negocio/ClientesNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/configuracion',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/ConfiguracionRest'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/zonasreparto',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/ZonasRepartoRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/carta',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/CartaRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/productos',
          name: 'Productos asociados',
          component: () => import('@/views/negocio/ProductosRestNegocio'),
          meta: {
            auth: true,
            role: ['admin', 'boss_restaurante'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/productoscatalogo',
          name: 'Catálogo de productos',
          component: () =>
            import('@/views/negocio/ProductosCatalogoRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/tarifascatalogo',
          name: 'Tarifas de catálogos',
          component: () => import('@/views/negocio/TarifasCatalogoRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/tpv',
          name: 'TPVs del negocio',
          component: () => import('@/views/negocio/TpvRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/reservas',
          name: 'Reservas del restaurante',
          component: () => import('@/views/negocio/ReservasRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        {
          path: 'gest/:negocio/restaurantes/:rest/horarios',
          name: 'Restaurantes',
          component: () => import('@/views/negocio/HorariosRestNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterRestaurante,
        },
        // PEDIDOS INTERNOS
        {
          path: 'gest/:negocio/internos/categorias',
          name: 'Categorías pedidos internos',
          component: () => import('@/views/internos/InternosCategorias'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/internos/productos',
          name: 'Productos pedidos internos',
          component: () => import('@/views/internos/InternosProductos'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/notificaciones',
          name: 'Notificaciones',
          component: () => import('@/views/negocio/NotificacionesNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/notificaciones/add',
          name: 'Crear Notificación',
          component: () => import('@/views/negocio/NotificacionesFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/noticias',
          name: 'Noticias',
          component: () => import('@/views/negocio/NoticiasNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/noticias/form',
          name: 'Crear Noticia',
          component: () => import('@/views/negocio/NoticiasFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/noticias/form/:id_noticia',
          name: 'Editar Noticia',
          component: () => import('@/views/negocio/NoticiasFormNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
        {
          path: 'gest/:negocio/integraciones',
          name: 'Integraciones Negocio',
          component: () => import('@/views/negocio/IntegracionesNegocio'),
          meta: {
            auth: true,
            role: ['admin'],
          },
          beforeEnter: beforeEnterNegocio,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!store.state.loaded) {
    store.watch(
      (state) => state.loaded,
      (value) => {
        if (value === true) {
          proceed();
        }
      }
    );
  } else {
    proceed();
  }

  function proceed() {
    let role_user = store.getters['auth/role'];
    if (role_user == 'cliente' || role_user == 'tpv') {
      //preguntar por los roles no validos
      store.dispatch('auth/firebaseLogout').then(() => {
        next({ path: '/login' });
      });
    }
    let role_page = to.meta.role;
    if (to.path.includes('/comprobarfirma')) {
      next();
    } else if (!store.state.auth.isLogged && to.path !== '/login') {
      next({ path: '/login' });
    } else if (
      (to.path == '/login' || to.path == '/') &&
      store.state.auth.isLogged
    ) {
      next({ path: goPanel() });
    } else if (role_page && !role_page.includes(role_user)) {
      next({ path: goPanel() });
    } else {
      document.title = to.name;
      next();
    }
  }
});

export default router;
